import React from "react";
import AdministrationFees from "../../features/administrationfees";

const ApplicationsFeesPage = () => <AdministrationFees />

export default ApplicationsFeesPage;